import { useQuery } from '@apollo/client';

import enterpriseRostersByProgramIdsOrContractIds from 'bundles/enterprise-admin-hooks/queries/EnterpriseRostersByProgramIdsOrContractIds.graphql';
import type {
  EnterpriseRostersByProgramIdsOrContractIdsQuery,
  EnterpriseRostersByProgramIdsOrContractIdsQueryVariables,
} from 'bundles/enterprise-admin-hooks/queries/__generated__/EnterpriseRostersByProgramIdsOrContractIds';

export const useRosters = ({
  programIds,
  contractIds,
  includeDeleted = false,
  skip = false,
}: {
  programIds?: string[];
  contractIds?: string[];
  includeDeleted?: boolean;
  skip?: boolean;
}) => {
  const { data, loading, error } = useQuery<
    EnterpriseRostersByProgramIdsOrContractIdsQuery,
    EnterpriseRostersByProgramIdsOrContractIdsQueryVariables
  >(enterpriseRostersByProgramIdsOrContractIds, {
    variables: {
      programIds,
      contractIds,
      includeDeleted,
    },
    skip,
    errorPolicy: 'all',
    context: { clientName: 'gatewayGql' },
  });
  const rosters = data?.EnterpriseRosters?.queryRostersByProgramIdsOrContractIdsOrBothAndIncludeDeleted.elements;
  return {
    rosters,
    loading,
    error,
  };
};
